module.exports = __webpack_public_path__ + "static/media/lds-logo_de.c2ae7627.svg";